import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { ERROR_MESSAGES } from "app/data/common/errorMessages";
import { CreateDropPayload, CreateDropResponse, StaticLoadResponse } from "app/data/static-load/model";

export const useCreateDrop = (onSuccess?: () => void) => {
  return useMutation<
    CreateDropResponse, // response type
    Error, // error type
    CreateDropPayload  // variables type
  >({
    mutationFn: async (payload) => {
      const response = await apiQueryAdapter.query<CreateDropResponse>(
        `/manifest-management/drops`,
        "POST",
        { body: payload }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.info("Drop created successfully");
      onSuccess?.();
    },
    onError: (e: any) => {
      if (e instanceof Error) {
        toast.error(e.message);
      }
      else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      }
      else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });
};

export const useDeleteDrop = (onSuccess?: () => void) => {
  return useMutation<
    StaticLoadResponse,
    Error,
    string
  >({
    mutationFn: async (dropId: string) => {
      const response = await apiQueryAdapter.query<StaticLoadResponse>(
        `/manifest-management/drops/${dropId}`,
        "DELETE",
      );

      return response.data;
    },
    onSuccess: () => {
      toast.info("Drop deleted successfully");
      onSuccess?.();
    },
    onError: (e: any) => {
      if (e instanceof Error) {
        toast.error(e.message);
      }
      else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      }
      else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });
};